// Canonical host is the `www` subdomain — every non-www / http request is 301'd
// to https://www.ncrechner.de at the CloudFront layer (see CLOUDFRONT_REDIRECTS.md),
// so canonical tags, OG urls and the sitemap must use the same host to avoid
// "canonical points to a different page" audit errors.
// In lokaler Entwicklung (`next dev`) fällt das sonst auf die Produktions-Domain
// zurück, obwohl im Browser localhost läuft – jeder SEO-Check auf localhost
// meldet dann fälschlich "canonical zeigt auf andere Seite". Deshalb hier
// bewusst auf localhost zeigen, solange kein Base-URL/Vercel-Kontext gesetzt ist.
export const baseUrl =
  process.env.NEXT_PUBLIC_BASE_URL ??
  (process.env.VERCEL_URL
    ? `https://${process.env.VERCEL_URL}`
    : process.env.NODE_ENV === "development"
      ? "http://localhost:3000"
      : "https://www.ncrechner.de");

// Site launch date — used as datePublished in structured data so crawlers find
// the original publish date (ISO 8601, schema.org CreativeWork).
export const siteLaunchDate = "2026-05-18";

// Last content update — used as dateModified in structured data and rendered as
// a visible "last updated" freshness signal in the footer. Bump this (ISO 8601)
// whenever site content is meaningfully revised. Keep it a real, static date —
// an auto-updating "today" date is treated as deceptive by search engines.
export const siteUpdatedDate = "2026-07-03";
export const siteUpdatedLabel = "Juli 2026";

// Official Facebook page (Organization sameAs, OG article:publisher).
export const facebookUrl = "https://www.facebook.com/ncrechner/";

// Googlebot preview directives for indexable pages (root layout + robotsFor()):
// large image previews (required for Google Discover) and unlimited snippets.
export const GOOGLEBOT_PREVIEW = {
  "max-image-preview": "large",
  "max-snippet": -1,
  "max-video-preview": -1,
} as const;
